import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class LoggerService {
    private static formatMessage(level: string, message?: any): string {
        return `[${level}][${new Date().toISOString().slice(0, -5).replace("T", " ")}] ${message}`;
    }

    public debug(message?: any, ...optionalParams: Array<any>): void {
        if (process.env.ENV === "production") {
            return;
        }

        console.debug(LoggerService.formatMessage("DEBUG", message));

        if (optionalParams) {
            optionalParams.forEach(optionalParam => console.debug(optionalParam));
        }
    }

    public info(message?: any, ...optionalParams: Array<any>): void {
        console.info(LoggerService.formatMessage("INFO", message));

        if (optionalParams) {
            optionalParams.forEach(optionalParam => console.info(optionalParam));
        }
    }

    public warn(message?: any, ...optionalParams: Array<any>): void {
        console.warn(LoggerService.formatMessage("WARN", message));

        if (optionalParams) {
            optionalParams.forEach(optionalParam => console.warn(optionalParam));
        }
    }

    public error(message?: any, ...optionalParams: Array<any>): void {
        console.error(LoggerService.formatMessage("ERROR", message));

        if (optionalParams) {
            optionalParams.forEach(optionalParam => console.error(optionalParam));
        }
    }
}
